import { setLocalStorage } from '@functions/localStorage';
import { FC, useEffect } from 'react';
import useEVMState from './features/evmStore/hooks/useEVMState';
import useStarknetState from './features/starknetStore/hooks/useStarknetState';
import useConnectedWeb3AccountsId from './hooks/useConnectedWeb3AccountsId';
import { CONNECTED_WEB3_ACCOUNTS_KEY } from './web3Store.variables';

const Web3Store: FC = () => {
	const [connectedWeb3AccountsId] = useConnectedWeb3AccountsId();

	useEVMState();
	useStarknetState();

	useEffect(() => {
		const timeout = setTimeout(() => {
			setLocalStorage(CONNECTED_WEB3_ACCOUNTS_KEY, connectedWeb3AccountsId);
		}, 200);

		return () => clearTimeout(timeout);
	}, [connectedWeb3AccountsId]);

	return null;
};
export default Web3Store;
